var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PMS6003-view"},[_c('weatherBar',_vm._b({staticStyle:{"margin-bottom":"10px"}},'weatherBar',_vm.status,false)),_c('sensortList',{attrs:{"list":_vm.seneorList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }